import axios, { encodeData } from "../utils/axios";

export const fetchSailors = async (
  resultsPerPage,
  page,
  search,
  orderBy,
  orderDirection,
  portAuthId
) => {
  const res = await axios
    .get("/sailors/", {
      params: {
        resultsPerPage,
        page,
        search,
        orderBy,
        orderDirection,
        portAuthId,
      },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });

  return res.data;
};

export const createSailor = async (newSailor) => {
  await axios.post("/sailors/create", encodeData(newSailor));
};

export const updateSailor = async (updateSailor) => {
  await axios.put("/sailors/update", encodeData(updateSailor));
};

export const deleteSailor = async (oldSailor) => {
  await axios.delete("/sailors/delete", {
    data: encodeData(oldSailor),
  });
};

export const fetchSingleSailorHistory = async (id) => {
  // Code if endpoint /sailors/history work
  const res = await axios
    .get("/sailors/history", {
      params: { id },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });
  return res.data;
};

export const fetchNaytikosInfoFromGateWay = async (id) => {
  const res = await axios
    .get("/sailors/getSailorFromGateWay", {
      params: { id },
    })
    .catch((error) => {
      if (error.response) {
        console.error(error);
      }
    });
  return res.data;
};
